export default "__VITE_ASSET__DNTxneZL__"